import React from 'react';
import { SessionStorage } from '../../../helpers';
import CustomBetDetails from './CustomBetDetails';

class CustomBet extends React.Component {

	render() {
		return (
			<div>
				<CustomBetDetails {...this.props} betTab ={SessionStorage.betTab}/>
			</div>
		)
	}
}

export default CustomBet